module.exports = __webpack_public_path__ + "media/images/favicon/primary/apple-icon-180x180-c7fe4ccc53509411f3ceb3e73b437010.png";